export const BASE_BLUE = '#063065';
export const BASE_BLUE_25 = '#cddcfc';
export const BASE_BLUE_50 = '#24355a';
export const BASE_BLUE_75 = '#369FFF';
export const WHITE = '#ffffff';
